import { BROWSER_TILE_KEYS } from "../../src/components/modules/Connect/BrowserWalletInfo/types"
import { HW_TILE_KEYS } from "../../src/components/modules/Connect/HumanWalletInfo/types"

export default {
  links: {
    goBack: "Volver",
    goBackToHome: "Volver a inicio",
  },
  humanWalletRegistration: {
    stepChip: "Paso 1 de 2",
    title: "Crea tu cuenta",
    description:
      "Solo necesitas un nombre de usuario. Después, tu dispositivo te pedirá FaceID o huella para crear tu passkey.",
    button: "Regístrate",
    form: {
      username: {
        placeholder: "Nombre de usuario",
      },
      conditions: {
        label:
          "Confirmo que he entendido que Tutellus no es responsable de guardar la clave privada de mi billetera, siendo yo el único responsable para ello.",
      },
      submit: {
        label: "Crear mi HumanWallet",
      },
    },
  },
  browserWalletConnect: {
    title: "Elige tu wallet",
    description: "Se abrirá tu extensión para aprobar la conexión.",
  },
  tutellus: "Tutellus",
  connect: "Conecta tu wallet",
  connectTo: "Conéctate a {{projectToken}}",
  connectTutellus_intro:
    "Accede a Tutellus con HumanWallet: una billetera fácil de usar, perfecta para acceso móvil y sin tarifas de gas.",
  account_HW: "¿Primera vez?",
  account_HW_bottom: "¿No tienes una cuenta de HumanWallet aún? ¿Quieres saber cómo funciona?",
  click_here: "Crea tu cuenta en 1 minuto",
  haveAccount: "¿Ya tienes cuenta?",
  loginLink: "Inicia sesión",
  detected: "Detectada",
  create_HW: "Crea tu usuario en 1 minuto y opera fácilmente en Web3 desde cualquier parte.",
  or: "o",
  connect_conventional: "Wallet de navegador",
  connect_browser: "Convencional",
  connect_abstracted: "Continuar con HumanWallet",
  connect_legal: "Al conectarte tendrás que firmar un disclaimer legal antes de usar el DEX.",
  connect_type: "¿Con qué tipo de wallet te quieres conectar?",
  hero: {
    eyebrow: "Acceso",
    lead: "El futuro crypto",
    emphasis: "empieza contigo",
    description: "Conecta para mintear tus POAPs y llevarte tus logros a tu wallet.",
    features: [
      "HumanWallet: entra con tu email, sin seed phrase.",
      "¿Ya tienes wallet? MetaMask y compatibles.",
      "Tus POAPs viven en tu dirección, no en nuestra base de datos.",
    ],
  },
  card_sub: "Un paso y dentro. Sin custodia por nuestra parte.",
  learn_browser: "¿Qué es una wallet de navegador?",
  learn_hw: "¿Cómo funciona HumanWallet?",
  dex_title: "Accede al servicio de POAPs",
  dex_description:
    "Un POAP es un NFT único e intransferible que reciben los Alumnos de Tutellus tras completar una formación.",
  browser_wallet: {
    eyebrow: "Wallet de navegador",
    heading: {
      lead: "Tus llaves,",
      emphasis: "tu control",
    },
    lead: "Conecta MetaMask o cualquier extensión compatible. Tutellus nunca toca tus claves: solo te pediremos una firma.",
    tiles: {
      [BROWSER_TILE_KEYS.SelfCustody]: {
        name: "Autocustodia",
        description: "Solo tú controlas tus claves privadas.",
      },
      [BROWSER_TILE_KEYS.Versatility]: {
        name: "Versatilidad",
        description: "La misma wallet para toda web3.",
      },
      [BROWSER_TILE_KEYS.Privacy]: {
        name: "Privacidad",
        description: "Nada se vincula a tu identidad.",
      },
    },
    know: {
      title: "Lo que debes saber",
      items: [
        "No existe «recuperar contraseña»: si pierdes tu seed phrase, nadie puede devolvértela.",
        "Comprueba siempre que firmas en el dominio oficial de Tutellus.",
      ],
    },
  },
  abstrated_wallet: {
    title: "HumanWallet",
    heading: {
      lead: "Entra con tu huella,",
      emphasis: "sin seed phrase",
    },
    lead: "La wallet integrada de Tutellus: una dirección real a tu nombre, firmada con la biometría de tu dispositivo.",
    tiles: {
      [HW_TILE_KEYS.Biometry]: {
        name: "Biometría",
        description: "Firmas con FaceID o huella. Sin contraseñas.",
      },
      [HW_TILE_KEYS.NoGas]: {
        name: "Sin gas",
        description: "Las tarifas de red las cubre Tutellus.",
      },
      [HW_TILE_KEYS.MultiDevice]: {
        name: "Multidispositivo",
        description: "La misma cuenta en cualquier equipo.",
      },
      [HW_TILE_KEYS.NoInstall]: {
        name: "Nada que instalar",
        description: "Vive dentro de la propia webapp.",
      },
    },
    know: {
      title: "Lo que debes saber",
      items: [
        "Tu wallet queda vinculada a tu biometría: ganas comodidad, cedes algo de privacidad.",
        "Tu clave la guarda tu proveedor de passkeys (Apple, Google u otro que elijas).",
      ],
    },
  },
  noWallets: {
    chip: "Sin wallets detectadas",
    title: "No encontramos ninguna extensión",
    description:
      "Este navegador no tiene wallets instaladas. Puedes instalar una o entrar sin extensión con HumanWallet.",
    cta: "Continuar con HumanWallet",
    install: "Instalar MetaMask",
  },
  wrongChain: {
    chip: "Red incorrecta",
    title: "Estás en otra red",
    description: "Tu wallet está conectada a una red distinta a la de los POAPs de Tutellus. Cámbiala para continuar.",
    cta: "Cambiar de red",
  },
  learn_more: "Saber más",
  switch_network: "Cambia de red",
  switch: "Switch",
  selectAccess: "Elige tu método de acceso",
  selectAccessText:
    "Selecciona tu wallet de navegador para mayor control o HumanWallet para una experiencia rápida y sencilla.",
  connect_intro:
    "Puedes usar un Wallet convencional o HumanWallet, con el que simplificamos el acceso a las operaciones.",
  connectWallet: "Conéctate con tu Wallet",
  connectWalletText: "Usa tu wallet de navegador para acceder de forma segura a tus dApps.",
  noConnectWallet: "No se detectaron wallets",
  noConnectWalletText:
    "Parece que no hay wallets de navegador disponibles en tu dispositivo. Por favor, instala una extensión de wallet como MetaMask o Brave Wallet para continuar, o intenta acceder con HumanWallet",
  register_or_login: "Inicia sesión o Regístrate si es la primera vez que usas HumanWallet con Tutellus ",
  login: "Iniciar sesión",
  loginText: "Accede con tu passkey y disfruta de una experiencia segura y rápida.",
  usernameWarning: "Introduce al menos tres caracteres",
  register: "Regístrate",
  registerText: "Crea tu cuenta con HumanWallet. Elige un nombre de usuario y comienza a usarlo sin complicaciones.",
  selectUserName: "Introduce tu nombre de usuario",
  userName: "Nombre de usuario",
  return_home: "Volver a inicio",
  loading: "Loading...",
  languages: {
    en: "EN",
    es: "ES",
  },
  learn_more_private_keys: "¿Dónde se guardan mis claves?",
  passkeys_modal_title: "Passkeys",
  passkeys_seed_heading: "¿Dónde se guarda la semilla de mi billetera HumanWallet?",
  passkeys_seed_text:
    "HumanWallet tiene integrados 2 estándares de última generación (ERC7212 y ERC4337), y este último transforma las billeteras en 'smart accounts', es decir, en contratos inteligentes, por lo que tu HumanWallet no tiene una semilla sino una clave privada asociada al contrato.",
  passkeys_key_heading: "¿Dónde se guarda la clave privada asociada a mi billetera HumanWallet?",
  passkeys_key_text:
    "La mayoría de los usuarios delegan el servicio 'passkeys' en Apple (llavero de iCloud) o Google (Password Manager), pero si quieres guardarlas en otro proveedor externo también puedes.",
  passkeys_providers_heading: "¿Qué otros proveedores existen para guardar las claves privadas?",
  passkeys_providers_text: "Hay muchos proveedores además de los 2 grandes (Apple y Google), como:",
  passkeys_providers_bitwarden: "una solución de código abierto que ofrece una gran seguridad y flexibilidad.",
  passkeys_providers_protonpass:
    "una alternativa enfocada en la privacidad y seguridad, ideal para quienes buscan máxima protección de sus datos.",
  and: "y",
  disclaimer:
    "Confirmo que he entendido que Tutellus no es responsable de guardar la clave privada de mi billetera, siendo yo el único responsable para ello.",
  back: "Volver al inicio",
}
